const SKILL_COLORS = {
  COMMUNICATION: '#EC4899',
  ENGAGEMENT: '#8B5CF6',
  CONTENT_ACCURACY: '#F59E0B',
  INSTRUCTIONAL_CLARITY: '#10B981',
  DEFAULT: '#3B82F6',
} as const;

const SKILL_COLOR_MAP: Record<string, string> = {
  communication_effectiveness: SKILL_COLORS.COMMUNICATION,
  student_engagement_rapport: SKILL_COLORS.ENGAGEMENT,
  content_accuracy_alignment: SKILL_COLORS.CONTENT_ACCURACY,
  instructional_clarity_structure: SKILL_COLORS.INSTRUCTIONAL_CLARITY,
};

// Whether the category has a colour of its own (getSkillColor falls back to DEFAULT otherwise).
export function hasSkillColor(skillKey: string): boolean {
  return !!SKILL_COLOR_MAP[skillKey];
}

export function getSkillColor(skillKey: string): string {
  if (!skillKey) {
    return SKILL_COLORS.DEFAULT;
  }
  return SKILL_COLOR_MAP[skillKey] || SKILL_COLORS.DEFAULT;
}
